import { render, staticRenderFns } from "./deduction-records.vue?vue&type=template&id=214c2ac2&"
import script from "./deduction-records.vue?vue&type=script&lang=js&"
export * from "./deduction-records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports